import React from "react";

const ConsultReportTabs = ({ registros, indice, onSelect, config }) => {
    return (
        <div
            className="ordenes"
            role="tablist"
            aria-label="Registros del reporte"
        >
            {registros.map((r, i) => {
                const primary = r[config.primary];
                const secondary = r[config.secondary];

                return (
                    <button
                        key={primary ?? i}
                        type="button"
                        className="orden-tab"
                        role="tab"
                        aria-selected={i === indice}
                        onClick={() => onSelect(i)}
                    >
                        <b>{primary}</b>
                        {secondary ? ` ${secondary}` : ""}
                    </button>
                );
            })}
        </div>
    );
};

export default ConsultReportTabs;
